export interface Token {
  name: string;
  symbol: string;
  description: string;
  imagePath: string;
  liquidity: number;
}

export interface Match {
  id: string;
  tokenA: Token | null;
  tokenB: Token | null;
  winner?: Token | null;
}

export interface Round {
  id: string;
  name: string;
  matches: Match[];
  roundNumber: number;
  tokenCount: number;
}

export interface Tournament {
  id: string;
  rounds: Round[];
  totalTokens: number;
  totalLiquidity: number;
}

export type RoundType =
  | "grand-finals"
  | "semi-finals"
  | "quarter-finals"
  | "standard";

export function getRoundType(tokenCount: number): RoundType {
  switch (tokenCount) {
    case 2:
      return "grand-finals";
    case 4:
      return "semi-finals";
    case 8:
      return "quarter-finals";
    default:
      return "standard";
  }
}

export function getRoundName(tokenCount: number): string {
  switch (tokenCount) {
    case 2:
      return "Grand Finals";
    case 4:
      return "Semi-Finals";
    case 8:
      return "Quarter-Finals";
    case 16:
      return "Round of 16";
    case 32:
      return "Round of 32";
    case 64:
      return "Round of 64";
    case 128:
      return "Round of 128";
    case 256:
      return "Round of 256";
    case 512:
      return "Round of 512";
    default:
      return `Round of ${tokenCount}`;
  }
}
